/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalSettingsService {
    private settingsURL: string = environment.host + '/globalSettings';
    private typeMetadataUrl: string = environment.host + '/company/metadata';

    constructor(private http: HttpClient) {}

    public getAllSettings() {
        return this.http.get(this.settingsURL.toString()).toPromise();
    }
    
    public getAllSettingsTabType() {
                const URL=this.settingsURL+ '?tabType=globalsettings/tab'
        return this.http.get(URL.toString()).toPromise();
    }

    public getTypeMetaData() {
        return this.http.get(this.typeMetadataUrl).toPromise();
    }

    public createUpdateSettings(companyData: any) {
        return this.http.post(this.settingsURL.toString(), companyData).toPromise();
    }
}
